module.exports = __webpack_public_path__ + "static/img/aliados_kueski.07dfd0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alliance/aliados_kueski.png
// module id = S+Za
// module chunks = 47